import Vue from 'vue'
import Vuex from 'vuex'
import api from './api'
import { LOGIN_URL } from './constants'

Vue.use(Vuex)

let keepaliveInterval = null

export default new Vuex.Store({
  state: {
    initialized: false,
    user: null,
    loginDialog: false,
  },

  mutations: {
    initialize(state) {
      state.initialized = true
    },
    openLoginDialog(state) {
      state.loginDialog = true
    },
    closeLoginDialog(state) {
      state.loginDialog = false
    },
    login(state, { user }) {
      state.user = user
    },
    logout(state) {
      state.user = null
    },
  },

  actions: {
    initialize(context) {
      return Promise.all([
        context.dispatch('loadCurrentUser'),
      ]).then(() => {
        context.commit('initialize')
      })
    },
    startKeepalive() {
      clearInterval(keepaliveInterval)
      keepaliveInterval = setInterval(() => {
        api.endpoints.auth.keepalive()
      }, 300000)
    },
    loadCurrentUser(context) {
      return api.endpoints.currentUser
        .get()
        .then(({ data }) => {
          if ('user' in data && data.user) {
            context.commit('login', { user: data.user })
          }
        })
        .catch(() => {
        })
    },
    openLoginDialog(context) {
      context.commit('openLoginDialog')
    },
    closeLoginDialog(context) {
      context.commit('closeLoginDialog')
    },
    login(context, { user }) {
      context.commit('login', { user })
    },
    logout(context) {
      return api.endpoints.auth.logout().then(() => {
        context.commit('logout')
        location.href = LOGIN_URL
      })
    },
  },
})
